import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import './style.css';
export var Modal = function (_a) {
    var children = _a.children, onClose = _a.onClose;
    var modalRef = useRef(null);
    var previouslyFocusedElement = useRef(null);
    useEffect(function () {
        var _a;
        // Сохранение элемента, который был в фокусе до открытия модала
        previouslyFocusedElement.current = document.activeElement;
        // Установка фокуса на модал при открытии
        (_a = modalRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        // Обработчик клавиши Esc для закрытия модала
        var handleKeyDown = function (e) {
            if (e.key === 'Escape') {
                onClose();
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        // Удаление обработчика и возврат фокуса при закрытии модала
        return function () {
            var _a;
            document.removeEventListener('keydown', handleKeyDown);
            (_a = previouslyFocusedElement.current) === null || _a === void 0 ? void 0 : _a.focus();
        };
    }, [onClose]);
    return (_jsx("div", { className: "modal-overlay", onClick: onClose, "aria-modal": "true", role: "dialog", children: _jsxs("div", { className: "modal-content", onClick: function (e) { return e.stopPropagation(); }, ref: modalRef, tabIndex: -1, children: [_jsx("button", { type: "button", className: "close-dogovor", onClick: onClose, "aria-label": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C", children: _jsx("img", { src: "/images/close_modal_dogovor.svg", alt: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C" }) }), children] }) }));
};
